/**
 * @file Share Modal.
 */

import { gsap } from 'gsap';

/**
 * Share Modal component.
 */
const vShareModal = () => {
	const shareModal = document.querySelector('.v-share-modal');

	if (!shareModal) {
		return;
	}

	let isAnimating = false;

	/**
	 * Open modal.
	 */
	const openModal = () => {
		if (isAnimating) return;

		isAnimating = true;

		gsap.set('.v-share-modal', {
			display: 'block',
		});

		gsap
			.timeline({
				defaults: {
					ease: 'sine.out',
					duration: 0.3,
				},
				onComplete: () => {
					isAnimating = false;
				},
			})
			.fromTo(
				'.v-share-modal',
				{
					opacity: 0,
				},
				{
					opacity: 1,
				},
			)
			.fromTo(
				'.v-share-modal__inner',
				{
					opacity: 0,
					y: 20,
					yPercent: -50,
				},
				{
					opacity: 1,
					y: 0,
					yPercent: -50,
					duration: 0.2,
				},
				'>',
			);
	};
	window.addEventListener('vOpenShareModal', openModal);

	const closers = shareModal.querySelectorAll(
		'.v-share-modal__close, .v-share-modal__overlay',
	);
	[...closers].forEach((closer) => {
		closer.addEventListener('click', () => {
			if (isAnimating) return;
			isAnimating = true;

			gsap
				.timeline({
					defaults: {
						ease: 'sine.out',
						duration: 0.3,
					},
					onComplete: () => {
						isAnimating = false;
						gsap.set('.v-share-modal, .v-share-modal__inner', {
							clearProps: 'all',
						});
					},
				})
				.to('.v-share-modal__inner', {
					opacity: 0,
					y: 20,
					yPercent: -50,
					duration: 0.2,
				})
				.to(
					'.v-share-modal',
					{
						opacity: 0,
					},
					'>',
				);
		});
	});
};

export default vShareModal;
